import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

export const isInActiveChat = (pushNotification: IPushNotification): boolean => {
  return Entities.App.isFocused && Entities.GroupsStore.activeGroupId === pushNotification.group;
};
